var _clipPath, _clipPath2, _style, _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_806",
    "data-name": "Group 806",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.887,
    height: 23.838,
    viewBox: "0 0 23.887 23.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 11.919,
    cy: 11.919,
    r: 11.919,
    style: {
      opacity: 0.506,
      fill: "#fff"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    className: "cls-2",
    cx: 12.526,
    cy: 12.526,
    r: 12.526
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    transform: "translate(-10)",
    d: "M0 0h34.283v20.921H0z"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n            .cls-7{fill:#fff}.cls-2{fill:none;stroke:#fff;stroke-width:2px}.cls-9{stroke:none}\n        "))), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M11.919 0A11.919 11.919 0 1 1 0 11.919 11.919 11.919 0 0 1 11.919 0z",
    transform: "translate(.049)",
    style: {
      opacity: 0.599
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_83",
    "data-name": "Mask Group 83",
    transform: "translate(.049)",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_64",
    "data-name": "Mask Group 64",
    transform: "translate(-.574 -.689)",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(6.884 3.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    className: "cls-7",
    d: "M260.107 0a4.091 4.091 0 1 1-4.091 4.091A4.091 4.091 0 0 1 260.107 0",
    transform: "translate(-254.465 2.918)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    className: "cls-7",
    d: "M0 829.818v-5.68c0-2.64 2.824-4.781 6.312-4.783a6.892 6.892 0 0 1 5.474 2.391 3.993 3.993 0 0 1 .395.6 4.215 4.215 0 0 1 .261.6 3.8 3.8 0 0 1 .2 1.2v5.68a1.069 1.069 0 0 1-1.182.9H1.185A1.071 1.071 0 0 1 0 829.82",
    transform: "translate(-.678 -807.794)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    className: "cls-2"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 11.919,
    cy: 11.919,
    r: 11.919
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 11.919,
    cy: 11.919,
    r: 10.919,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_435",
    "data-name": "Path 435",
    style: {
      fill: "none"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.822 0A10.822 10.822 0 1 1 0 10.822 10.822 10.822 0 0 1 10.822 0z",
    transform: "translate(1.122 1.208)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.822 1C5.406 1 1 5.406 1 10.822c0 5.416 4.406 9.822 9.822 9.822 5.416 0 9.822-4.406 9.822-9.822C20.644 5.406 16.238 1 10.822 1m0-1c5.977 0 10.822 4.845 10.822 10.822 0 5.977-4.845 10.822-10.822 10.822C4.845 21.644 0 16.799 0 10.822 0 4.845 4.845 0 10.822 0z",
    style: {
      fill: "#000",
      stroke: "none"
    },
    transform: "translate(1.122 1.208)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.906d5c8d.svg";
export { ForwardRef as ReactComponent };